import { render } from "./Tasks.vue?vue&type=template&id=63f41c7b"
import script from "./Tasks.vue?vue&type=script&lang=js"
export * from "./Tasks.vue?vue&type=script&lang=js"
script.render = render

export default script